import { useEffect } from "react";

// Lenis chargé en dynamic import après le FCP/LCP.
// Cela retire ~15 KB du bundle initial + tout le CPU d'init au premier paint.
// Sur mobile, on désactive complètement Lenis (pas de scroll fluide requis).
export default function SmoothScroll({ children }) {
  useEffect(() => {
    // Skip sur mobile / prefers-reduced-motion / tactile pur : pas de gain UX,
    // que du CPU consommé pour PSI.
    const isMobile = window.matchMedia("(max-width: 767px)").matches;
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (isMobile || reduce) return;

    let cancelled = false;
    let cleanup = null;

    const start = async () => {
      const { default: Lenis } = await import("lenis");
      if (cancelled) return;
      const lenis = new Lenis({
        duration: 1.15,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        smoothWheel: true,
      });
      let raf;
      const loop = (time) => {
        lenis.raf(time);
        raf = requestAnimationFrame(loop);
      };
      raf = requestAnimationFrame(loop);

      const onClick = (e) => {
        const a = e.target.closest('a[href*="#"]');
        if (!a) return;
        const url = new URL(a.getAttribute("href"), window.location.href);
        if (url.pathname === window.location.pathname && url.hash) {
          const el = document.querySelector(url.hash);
          if (el) {
            e.preventDefault();
            lenis.scrollTo(el, { offset: -70, duration: 1.4 });
            window.history.pushState(null, "", url.hash);
          }
        }
      };
      document.addEventListener("click", onClick);

      cleanup = () => {
        cancelAnimationFrame(raf);
        lenis.destroy();
        document.removeEventListener("click", onClick);
      };
    };

    // Attend l'idle pour ne pas peser sur FCP/LCP
    const schedule = window.requestIdleCallback || ((cb) => setTimeout(cb, 200));
    const id = schedule(start, { timeout: 2000 });

    return () => {
      cancelled = true;
      if (window.cancelIdleCallback && typeof id === "number") window.cancelIdleCallback(id);
      if (cleanup) cleanup();
    };
  }, []);

  return children;
}
